import * as React from "react";

import { Module } from "@com.mgmtp.a12.client/client-core/lib/core/application";
import { View } from "@com.mgmtp.a12.client/client-core/lib/core/view";

import { OpenregisterSelectRecordModal } from "./components/OpenregisterSelectRecordModal";
import { openSelectRecordModalSaga } from "./sagas/openSelectRecordModalSaga";
import { selectOpenRegisterRecordSaga } from "./sagas/selectOpenRegisterRecordSaga";
import { upsertOpenRegisterRecordSaga } from "./sagas/upsertOpenRegisterRecordSaga";

const components: Record<string, React.ComponentType<View> | undefined> = {
	OpenregisterSelectRecordModal
};

function viewComponentProvider(name: string) {
	return components[name];
}

const openregisterUpsertModule = (): Module => ({
	id: "openregisterUpsertModule",
	views: () => viewComponentProvider,
	sagas: () => [upsertOpenRegisterRecordSaga, openSelectRecordModalSaga, selectOpenRegisterRecordSaga]
});

export default openregisterUpsertModule;
